import { Stack } from "@mui/material";
import { CostTable } from "./CostTable";
import { CostTabData } from "../types";
import { typeSafeObjectEntries } from "src/utils/typeSafeObjectEntries";
import { useIsAdmin } from "hooks/settings";
import { TableHeader } from "../TableHeader";
import { useTenantTranslation } from "hooks/formatters";

interface Props {
  data: CostTabData;
  selectedDate: Date;
}

export const CostTableList = ({ data, selectedDate }: Props) => {
  const isAdmin = useIsAdmin();
  const { t } = useTenantTranslation();
  const sourceData = isAdmin
    ? typeSafeObjectEntries(data)
    : typeSafeObjectEntries(data).filter(
        ([source]) => source !== "charged_cost_diff_timeseries"
      );
  return (
    <Stack spacing={1}>
      <TableHeader
        titlePrefix={t("costDuring")}
        subtitleText={t("costTableSubtitleText")}
        selectedDate={selectedDate}
        formatDateMonthly
      />
      {sourceData.map(([tableSource, tableData]) => (
        <CostTable
          key={tableSource}
          tableSource={tableSource}
          tableData={tableData}
          selectedDate={selectedDate}
        />
      ))}
    </Stack>
  );
};
